import { combineReducers } from 'redux';

import errorReducer from './errorReducer';
import authReducer from './authReducer';
import organizationReducer from './organizationReducer';
import overviewReducer from './overviewReducer';
import countersReducer from './countersReducer';
import reportsReducer from './reportsReducer';
import appsReducer from './appsReducer';
import globalReducer from './globalReducer';
import trackingReducer from './trackingReducer';
import selfFilesReducer from './selfFilesReducer';
import staffReducer from './staffReducer';

export default combineReducers ({
	errors: errorReducer,
	auth: authReducer,
	organization: organizationReducer,
	overview: overviewReducer,
	counters: countersReducer,
	reports: reportsReducer,
	apps: appsReducer,
	global: globalReducer,
	tracking: trackingReducer,
	selfFiles: selfFilesReducer,
	staff: staffReducer
});
